import { useAppMutation } from '@/helpers/api/mutation'

import { createInstance } from '@/helpers/api/base'
import { useNotification } from '@/ui/Notification'
import { Disruption } from '@/types/disruptions'
import { useModal, DeleteModalProps, ModalTypes } from '@/components/Modal'

export const useDeleteDisruption = (disruption: Disruption) => {
    const { showNotification } = useNotification()
    const { openModal } = useModal()

    const deleteDisruption = useAppMutation<void, Error, number, Disruption[]>({
        mutationFn: (logId: number) =>
            createInstance({
                url: `/disruptions`,
                method: 'DELETE',
                params: { disruptionId: logId },
            }),
        alertOnError: true,
        queryKey: ['GET_DISRUPTIONS'],
        optimisticChangesCallback: (requestBody: number, previousData?: Disruption[]) =>
            previousData ? previousData.filter((item) => item.id !== requestBody) : [],
        onSuccess: () => {
            showNotification({ message: 'Disruption deleted' })
        },
    })

    const handleDeleteDisruption = () => {
        const displayFallback = !disruption.reference

        openModal<DeleteModalProps>(ModalTypes.deleteModal, {
            title: 'Delete disruption?',
            message: (
                <>
                    This will delete <strong>{displayFallback ? 'this item' : <>{disruption.reference}</>}</strong>.
                    This cannot be undone.
                </>
            ),
            onDelete: () => {
                deleteDisruption.mutate(disruption.id)
            },
        })
    }

    return {
        handleDeleteDisruption,
    }
}
